import { UserInfo } from '../../generated/auth/models/Sasfin/Wealth/Online/Auth/Models/user-info';

export interface IAuthState {
  token: string;
  userInformation: UserInfo;
  isLoading: boolean;
}

export const initialAuthState = {
  isLoading: false,
};
